import { render, staticRenderFns } from "./StockTrend.vue?vue&type=template&id=92faa2bc&scoped=true"
import script from "./StockTrend.vue?vue&type=script&lang=js"
export * from "./StockTrend.vue?vue&type=script&lang=js"
import style0 from "./StockTrend.vue?vue&type=style&index=0&id=92faa2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92faa2bc",
  null
  
)

export default component.exports